import React, { useState } from 'react';
import EventLocationLayer from './EventLocationLayer';
import EventStatusLayer from './EventStatusLayer';
import EventTypeLayer from './EventTypeLayer';
import EventDelayCodesLayer from './EventDelayCodesLayer';
import EventResponsibilityLayer from './EventResponsibilityLayer';

const tabs = [
  { key: 'eventLocation', label: 'Event Location', Component: EventLocationLayer },
  { key: 'eventStatus', label: 'Event Status', Component: EventStatusLayer },
  { key: 'eventType', label: 'Event Type', Component: EventTypeLayer },
  { key: 'eventDelayCodes', label: 'Event Delay Codes', Component: EventDelayCodesLayer },
  { key: 'eventResponsibility', label: 'Event Responsibility', Component: EventResponsibilityLayer },
];

const EventTablesLayer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find((tab) => tab.key === activeTab)?.Component || tabs[0].Component;

  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map((tab) => (
            <li key={tab.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default EventTablesLayer;
